import { render, staticRenderFns } from "./boleto.vue?vue&type=template&id=ed4407d6&scoped=true"
import script from "./boleto.vue?vue&type=script&lang=js"
export * from "./boleto.vue?vue&type=script&lang=js"
import style0 from "./boleto.vue?vue&type=style&index=0&id=ed4407d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4407d6",
  null
  
)

export default component.exports